export default {
  signatories: [],
  searchParams: {
    orders: [
      {
        fieldName: 'fullname',
        orderBy: 'ASC',
      },
    ],
    params: [],
    offset: 0,
    limit: 20,
  },
  pagination: {
    current: 1,
    total: 1,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/signatory/state.js